import antdEn from 'antd/lib/locale-provider/en_US';
import enMessages from '../locales/en_US.json';

const enLang = {
    messages: enMessages,
    antd: antdEn,
    locale: 'en',
};
export default enLang;
